'use client'
import React from 'react'

import { useEffect, useRef } from 'react'
import { useWebContainerStore } from '@/lib/webcontainer-store'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Terminal as TerminalIcon } from 'lucide-react'

export function Terminal() {
  const { terminalOutput, isBooting, isReady } = useWebContainerStore()
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight
    }
  }, [terminalOutput])

  return (
    <div className="h-full flex flex-col bg-[color:var(--terminal-bg)]">
      <div className="flex items-center gap-2 px-3 py-2 border-b border-border bg-muted/30">
        <TerminalIcon className="h-4 w-4 text-primary" />
        <span className="text-sm font-medium text-foreground">Terminal</span>
        {isBooting && (
          <span className="text-xs text-muted-foreground animate-pulse">Booting WebContainer...</span>
        )}
        {isReady && (
          <span className="text-xs text-accent">Ready</span>
        )}
      </div>
      <ScrollArea className="flex-1 p-3 height-300" ref={scrollRef}>
        <div className="font-mono text-xs space-y-0.5">
          {terminalOutput.length === 0 ? (
            <div className="text-muted-foreground">
              {isBooting ? 'Initializing WebContainer...' : 'Terminal output will appear here...'}
            </div>
          ) : (
            terminalOutput.map((line, index) => (
              <div 
                key={index} 
                className={
                  line.startsWith('[error]') || line.toLowerCase().includes('error')
                    ? 'text-destructive'
                    : line.startsWith('[warn]') || line.toLowerCase().includes('warning')
                    ? 'text-yellow-500'
                    : line.startsWith('[success]') || line.includes('ready')
                    ? 'text-accent'
                    : 'text-foreground/80'
                }
              >
                {line}
              </div>
            ))
          )}
        </div>
      </ScrollArea>
    </div>
  )
}
